// gestione errore centralizzata usata con ErrorSnackbar.vue
const state = () => ({
  errorSnackbar: {
    show: false,
    message: ''
  }
});

const mutations = {
  HANDLE_ERROR (context, error) {
    if (!this.state.errorsModule) {
      this.state.errorsModule = [];
    }
    let messageDisplay = '';
    if (error.message.length > 0 && error.message[0].constraints) {
      messageDisplay = error.message[0].property + ' ' + error.message[0].constraints.constraintName;
    } else {
      messageDisplay = error.message;
    }

    this.state.errorsModule.errorSnackbar = {
      show: error.show,
      message: messageDisplay
    };
    // non capisco perchè serva...
    this.state.errorSnackbar = {
      show: error.show,
      message: messageDisplay
    };
  }
};

export default {
  namespaced: true,
  state,
  mutations
};